<app-pageheader Title="Reports" [RefreshTarget]="dataList"></app-pageheader>

<app-datalistview #dataList
  [Columns]="Columns"
  ApiUrl="reporting/reports/search"
  [AllowEdit]="true"
  EditUrl="/reports/run/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>